import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ContextCardSection } from '@shared/models/course.model';
import { CoursesAPIService } from '@shared/services/coursesApi.service';

@Component({
  selector: 'context-card-section',
  templateUrl: './context-card-section.component.html',
  styleUrls: ['./context-card-section.component.scss']
})
export class ContextCardSectionComponent implements OnChanges {
  @Input() section: ContextCardSection;
  @Input() courseId: string;
  @Input() index: number;
  @Input() canDelete = true;
  @Input() isCardEnabled = false;

  @Output() changed = new EventEmitter<{ data: ContextCardSection; index: number }>();
  @Output() deleted = new EventEmitter<number>();

  isExpanded = false;
  shouldExpand = false;
  titleAppearance = 'none';

  constructor(private _courseApiService: CoursesAPIService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['section']?.firstChange) {
      this.shouldExpand = this.index === 0 || !this.section?.content;
    }
  }

  onNameChange(): void {
    this.changed.emit({ data: this.section, index: this.index });
  }

  onContentChange(html: string): void {
    this.section.content = html;
    this._courseApiService.patchCourse(this.courseId, {
      op: 'replace',
      path: `information.contextCard.sections[${this.index}].content`,
      value: html,
    }).subscribe();
  }

  disableKeyboardToggle(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.code === 'Enter') {
      event.stopImmediatePropagation();
    }
  }

  onTitleClick(event: Event): void {
    if (this.isExpanded) {
      event.stopPropagation();
    }
  }

  onExpandedChange(expanded: boolean): void {
    this.isExpanded = expanded;
    this.titleAppearance = expanded ? 'fill' : 'none';
  }

  onDeleteClick(event: Event): void {
    this.deleted.emit(this.index);
    event.stopPropagation();
  }
}
